import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0646c86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "text-grey-darken-1 text-subtitle-1 font-weight-bold" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "###", -1))

import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Table',
  props: ['title', 'items', 'columns', 'keyFilter'],
  setup(__props) {

const props = __props;


const textFilter = ref('');
const page = ref(1);
const qtdPerPage = 10;

const showPagination = computed(() => textFilter.value.length === 0);
const paginationLength = computed(() => {
    return Math.ceil(props.items.length / qtdPerPage);
});
const selectedItems = computed(() => {
    if (textFilter.value.length === 0) {
        const endWith = (page.value * qtdPerPage);
        let startFrom = endWith - qtdPerPage;
        if (startFrom <= 0) {
            startFrom = 0;
        }

        return props.items.slice(startFrom, endWith);
    } else {
        const keys = props.keyFilter.split('.');
        switch (keys.length) {
        case 1:
            return props.items.filter((item: any) => item[props.keyFilter].includes(textFilter.value));
        case 2:
            return props.items.filter((item: any) => {
                const value = item[keys[0]][keys[1]];
                return value.includes(textFilter.value);
            });
        default:
            throw new DOMException(`Invalid key filter: ${props.keyFilter}`);
        }
    }
});

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_row, { justify: "space-around" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { width: "100%" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, { color: "surface" }, {
            append: _withCtx(() => [
              _renderSlot(_ctx.$slots, "append-title")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 3
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                justify: "center",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: textFilter.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textFilter).value = $event)),
                        variant: "outlined",
                        density: "compact",
                        placeholder: "Filtrar"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("table", _hoisted_1, [
                _createElementVNode("tr", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(column.title), 1))
                  }), 128)),
                  _hoisted_3
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedItems), (item) => {
                  return (_openBlock(), _createBlock(_component_v_hover, {
                    key: item.id
                  }, {
                    default: _withCtx(({ isHovering, props }) => [
                      _createElementVNode("tr", _mergeProps({
                        class: {'on-hover': isHovering}
                      }, props), [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: column.key
                          }, [
                            _renderSlot(_ctx.$slots, "value-content", {
                              item: item,
                              colunm: column
                            }, () => [
                              _createTextVNode(_toDisplayString(item[column.key]), 1)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("td", null, [
                          _renderSlot(_ctx.$slots, "edit-button", { item: item }),
                          _renderSlot(_ctx.$slots, "remove-button", { item: item }),
                          _renderSlot(_ctx.$slots, "custom-button", { item: item })
                        ])
                      ], 16)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            _: 3
          }),
          (_unref(showPagination))
            ? (_openBlock(), _createBlock(_component_v_pagination, {
                key: 0,
                class: "py-10",
                modelValue: page.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((page).value = $event)),
                length: _unref(paginationLength),
                rounded: "circle",
                "prev-icon": "mdi:mdi-menu-left",
                "next-icon": "mdi:mdi-menu-right"
              }, null, 8, ["modelValue", "length"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})